export default {
  heading: "家庭",
  home: {
    error: {
      noEmail: "由于家庭成员帐户需要有电邮地址，请<a href='{link}'>按此</a>更新个人资料中的登入电邮。",
      functionalAccount: "此家庭功能只供学生会员及公众会员使用，请更换帐户再尝试。",
      studentAccount: "此家庭功能只供学生会员、公众会员及正式会员使用，请<a href='{link}'>按此</a>升级帐户为学生会员。",
      cannotCreateOrJoin: "发生问题。",
      full: "家庭成员已满。",
      expired: "家庭验证码已过期，请联繫家庭管理员重新生成",
    },
  },
  index: {
    heading: "建立家庭",
    text: {
      info: "欢迎使用家庭群组服务！",
      info2: "会员加入家庭群组后，家庭成员将能查看其他会员的帐户资料及活动记录。",
      studentInfo: "欢迎使用家庭群组服务！",
      hint: "* 一个帐户只能同时进入一个家庭群组",
      or: "或",
      formInfo: "请输入家庭资讯",
      recaptcha: "reCAPTCHA 暂时停用",
      createInfo: "建立家庭，并邀请成员加入",
      shareMessage: "您可以透过电邮或WhatsApp邀请家人建立新家庭",
    },
    label: {
      familyName: "家庭名称",
      nickname: "您的暱称",
      role: "您的家庭角色",
      submit: "完成",
      back: "返回",
      receiverEmail: "收件人电邮",
      invite: "邀请建立家庭",
    },
    placeholder: {
      nickname: "最多100个字元",
    },
    validation: {
      familyNameIsEmpty: "请输入家庭名称。",
      nicknameIsEmpty: "请输入您的暱称。",
      roleIsEmpty: "请选择家庭角色。",
      roleIsInvalid: "家庭角色不正确，请重新选择。",
      familyNameBadword: "切勿使用不雅用语，请输入其他家庭名称。",
      familyNameExceedMax: "请输入最多100个字元。",
      nicknameBadword: "切勿使用不雅用语，请输入其他暱称。",
      nicknameExceedMax: "请输入最多100个字元。",
      receiverEmailIsEmpty: "请输入收件人电邮地址。",
      receiverEmailFormatWrong: "电邮地址格式不正确，请重新输入。",
    },
    button: {
      create: "建立家庭",
      join: "加入家庭",
      faq: "常见问题",
      video: "教学影片",
      invite: "邀请建立家庭",
      email: "电邮",
      send: "发送",
      cancel: "取消",
    },
    confirmCreate: {
      message: "请确认建立家庭",
      confirm: "建立"
    }
  },
  join: {
    heading: "加入家庭",
    text: {
      info: "请输入家庭资讯",
      expired: "加入连结已过期",
      incorrect: "加入连结不正确",
      recaptcha: "reCAPTCHA 暂时停用",
    },
    label: {
      adminEmail: "管理员电邮",
      code: "家庭验证码",
      nickname: "您的暱称",
      role: "家庭角色",
      familyRef: "家庭编号",
    },
    button: {
      submit: "完成",
      back: "返回",
    },
    placeholder: {
      nickname: "最多100个字元",
    },
    validation: {
      adminEmailIsEmpty: "请输入家庭管理员电邮地址。",
      codeIsInvalid: "家庭验证码格式不正确，请重新输入。",
      codeIsEmpty: "请输入家庭验证码。",
      nicknameIsEmpty: "请输入暱称。",
      roleIsEmpty: "请选择家庭角色。",
      roleIsInvalid: "家庭角色不正确，请重新选择。",
      adminEmailFormatWrong: "电邮地址格式不正确，请重新输入。",
      adminEmailNotFound: "找不到此家庭管理员电邮地址。",
      codeNotMatch: "输入的家庭验证码与输入的家庭管理员的家庭验证码不相符。",
      groupNotFound: "找不到对应的家庭",
      nicknameBadword: "切勿使用不雅用语，请输入其他暱称。",
      nicknameExceedMax: "请输入最多100个字元。",
      familyRefIsEmpty: "请输入家庭编号。",
      familyRefExceedMax: "请输入最多10个字元。",
    }
  },
  hold: {
    info: "24小时内已尝试提交错误申请5次，请在{displayDatetime}之后再尝试。"
  },
  request: {
    text: {
      info: "您可以撤回家庭管理员未处理的请求或被拒绝的请求",
      wait: "有关讯息已发到家庭管理员， 正在等候管理员同意。",
      decline: "管理员拒绝了加入的请求。",
      kick: "管理员已将您从家庭中移除。",
      dismiss: "管理员解散了家庭。",
      group: "家庭资讯",
    },
    button: {
      cancel: "取消申请",
      acknowledged: "我知道了",
      refresh: "重新整理",
    },
    confirmWidthdraw: {
      message: "撤回加入此家庭的请求？",
    },
  },
  details: {
    text: {
      dismissed: "此家庭已经被解散了，请按离开家庭。",
      editDialogTitle: "修改资料",
      copied: "已複制加入连结。",
      updated: "已修改资料。",
      expired: "家庭验证码已逾期，请于刷新后再次複制。",
      regened: "已刷新家庭验证码。",
      left: "您已离开家庭。",
      notMember: "您已离开家庭。",
      beKicked: "您已被管理员从家庭中移除。",
      dismiss: "此家庭已经被解散。",
      memberUpdated: "已修改您的成员资料。",
      accepted: "已接受成员加入此家庭。",
      declined: "已拒绝成员加入此家庭。",
      kicked: "此成员已被管理员从家庭中移除。",
      kickout: "此成员已离开此家庭。",
      withdrawn: "用户已撤回加入请求。",
      processed: "请求已被处理。",
      handled: "不能撤回已处理的请求。",
      upgraded: "成员已被列为管理员。",
      downgraded: "已取消此成员的管理员身分。",
      acceptedAndUpgraded: "已接受用户加入此家庭并将其列为管理员。",
      notAdmin: "您已被取消管理员权限。",
      singleAdmin: "由于每个家庭必须有至少一 个管理员，此操作无法执行。",
      multipleAdmin: "由于有多名家庭管理员，此操作无法执行。",
      notUpgrade: "此成员已经是家庭管理员。",
      notDowngrade: "此成员已不再是管理员。",
      shareInfo: "可透过发送连结或邀请其他用户输入家庭编号和验证码加入家庭。",
      expiredEmail: "家庭验证码已逾期，请刷新后再发送邀请电邮。",
      expiredWhatsapp: "家庭验证码已逾期，请刷新后再发送WhatsApp邀请连结。",
      member: "家庭成员 {nickname}",
      cannotDismiss: "由于此家庭有多于一个管理员，无法使用此功能。",
      cannotLeave: "由于家庭只有一个管理员，无法使用此功能。",
      error: "发生问题。",
      requestNotFound: "找不到对应的请求。",
      memberNotFound: "找不到对应的成员。",
    },
    label: {
      familyName: "家庭名称",
      createDate: "家庭验证码生成日期",
      expiryDate: "家庭验证码到期日期",
      request: "请求",
      member: "成员",
      role: "家庭角色",
      status: "状态",
      actions: "行动",
      expired: "已过期",
      you: "您",
      dismissed: "已解散",
      admin: "管理员",
      person: "人",
      memberList: "成员列表",
      requestList: "请求列表",
      receiverEmail: "收件人电邮",
      familyRef: "家庭编号",
      nickname: "您的暱称",
      editRole: "家庭角色",
      code: "家庭验证码",
    },
    placeholder: {
      nickname: "最多只能100个字母",
    },
    validation: {
      familyNameIsEmpty: "请输入家庭名称。",
      familyNameBadword: "切勿使用不雅用语，请输入其他家庭名称。",
      familyNameExceedMax: "输入长度超过限制。",
      roleIsEmpty: "请选择家庭角色。",
      roleIsInvalid: "家庭角色不正确，请重新选择。",
      nicknameIsEmpty: "请输入暱称。",
      nicknameBadword: "切勿使用不雅用语，请输入其他暱称。",
      nicknameExceedMax: "输入长度超过限制。",
      receiverEmailIsEmpty: "请输入收件人电邮地址。",
      receiverEmailFormatWrong: "电邮地址格式不正确，请重新输入。",
    },
    button: {
      update: "修改家庭名称",
      regenerate: "刷新验证码",
      dismiss: "解散家庭",
      leave: "退出家庭",
      edit: "编辑资料",
      cancel: "取消",
      previous: "上一页",
      next: "下一页",
      share: "複制加入超链结",
      familyInfo: "邀请成员",
      refresh: "重新整理",
      confirm: "确定",
      acceptMember: "允许加入",
      declineMember: "拒绝加入",
      kick: "移除成员",
      upgrade: "授予管理员权限",
      downgrade: "取消其管理员身分",
      acceptAndUpgrade: "允许加入并授予管理员权限",
      send: "发送",
      invite: "邀请",
      email: "电邮",
      execute: "修改",
      copy: "複制邀请连结",
      yes: "是",
      no: "否",
      decline: "拒绝",
    },
    confirmRegenerate: {
      message: "确认刷新家庭验证码？"
    },
    confirmAccept: {
      message: "允许{nickname}加入家庭？"
    },
    confirmDecline: {
      message: "拒绝{nickname}加入此家庭？"
    },
    confirmKick: {
      message: "确认将此成员{nickname}从家庭中移除？",
    },
    confirmDismiss: {
      message: "确认解散此家庭？",
    },
    confirmLeave: {
      message: "确认离开此家庭？",
    },
    confirmUpgrade: {
      message: "确认将此成员{nickname}列为管理员？",
    },
    confirmDowngrade: {
      message: "确认取消此成员{nickname}的管理员身分？",
    },
    confirmAcceptAndUpgrade: {
      message: "接受此成员{nickname}加入家庭并授予此成员管理员权限？",
    },
    share: {
      title: "我邀请您于教城加入家庭",
      content: "我想邀请您于香港教育城（教城）加入一个家庭。",
      email: {
        subject: "{fullname} 想邀请您于教城加入家庭",
        content: "您好! \n \n 为提升亲子学习交流，我想邀请您于香港教育城（教城）加入一个家庭。要了解教城更多，点击以下连结： \n https://www.edcity.hk/hq/zh-hant/content/aboutus \n 如您尚未有教城帐户，请点击以下连结申请： \n https://www.edcity.hk/hq/zh-hant/content/membership/public \n 如您已有教城的帐户，请点击以下连结，登入帐户后即可加入家庭：\n {familyLink} \n \n 您的家庭成员 \n {fullname}",
      },
    },
  },
  share: {
    title: "我邀请您于教城建立家庭",
    content: "我想邀请您于香港教育城（教城）建立一个家庭。",
    email: {
      subject: "{fullname} 想邀请您于教城建立家庭",
      content: "您好! \n \n 为提升亲子学习交流，我想邀请您于香港教育城（教城）建立一个家庭。要了解教城更多，请点击以下连结： \n https://www.edcity.hk/hq/zh-hant/content/aboutus \n 如您尚未有教城帐户，请点击以下连结登记： \n https://www.edcity.hk/hq/zh-hant/content/membership/public \n 如您已有教城的帐户，请点击以下连结，登入帐户后即可建立家庭：\n {familyLink} \n \n 您的家庭成员 \n {fullname}",
    },
  },
};
